var _path, _path2, _path3, _path4, _rect, _path5, _path6, _path7, _path8, _g, _path9, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 149,
    height: 121,
    viewBox: "0 0 149 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 17.0786C16 13.7215 18.7215 11 22.0786 11H119.921C123.279 11 126 13.7215 126 17.0786V114.921C126 118.279 123.279 121 119.921 121H22.0786C18.7215 121 16 118.279 16 114.921V17.0786Z",
    fill: "#E5F6EE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 105V68C5.5 63.5817 9.08172 60 13.5 60H41",
    stroke: "#003311",
    strokeWidth: 2,
    strokeDasharray: "2 4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.30218 99H1.69922V106.603H9.30218V99Z",
    fill: "#22EE88",
    stroke: "#003311",
    strokeWidth: 2.27947,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M97.5 60H125C129.418 60 133 56.4183 133 52V24",
    stroke: "#003311",
    strokeWidth: 2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 117,
    width: 32,
    height: 32,
    rx: 5.12,
    fill: "#003311"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M133.305 5.97842C127.593 5.97842 122.945 10.6256 122.945 16.3384C122.945 22.0512 127.593 26.6984 133.305 26.6984C139.018 26.6984 143.665 22.0512 143.665 16.3384C143.665 10.6256 139.014 5.97842 133.305 5.97842ZM133.305 25.9584C128 25.9584 123.685 21.6442 123.685 16.3384C123.685 11.0326 128 6.71842 133.305 6.71842C138.611 6.71842 142.925 11.0326 142.925 16.3384C142.925 21.6442 138.611 25.9584 133.305 25.9584Z",
    fill: "#22EE88"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M135.632 12.3758L133.305 14.7031L130.977 12.3758H130.456L129.346 13.4858V14.0075L131.673 16.3348L129.346 18.6621V19.1838L130.456 20.2938H130.977L133.305 17.9665L135.632 20.2938H136.154L137.264 19.1838V18.6621L134.936 16.3348L137.264 14.0075V13.4858L136.154 12.3758H135.632ZM134.152 16.0758V16.5975L136.479 18.9248L135.891 19.5131L133.564 17.1858H133.042L130.715 19.5131L130.126 18.9248L132.454 16.5975V16.0758L130.126 13.7485L130.715 13.1602L133.042 15.4875H133.564L135.891 13.1602L136.479 13.7485L134.152 16.0758Z",
    fill: "#22EE88"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M132.083 13.9574L131.258 13.2349C130.968 12.9814 130.54 12.9653 130.232 13.1963C129.835 13.4938 129.794 14.0737 130.145 14.4243L130.851 15.131C131.508 15.7876 131.508 16.8523 130.851 17.509L130.145 18.2157C129.794 18.5663 129.835 19.1462 130.232 19.4437C130.54 19.6747 130.968 19.6586 131.258 19.4051L132.083 18.6825C132.792 18.0627 133.849 18.0627 134.558 18.6825L135.37 19.393C135.657 19.6445 136.09 19.6301 136.36 19.36C136.631 19.0899 136.645 18.6566 136.393 18.3691L135.683 17.5572C135.063 16.8488 135.063 15.7911 135.683 15.0828L136.393 14.2709C136.645 13.9834 136.631 13.5501 136.36 13.28C136.09 13.0099 135.657 12.9955 135.37 13.247L134.558 13.9574C133.849 14.5773 132.792 14.5773 132.083 13.9574Z",
    fill: "#22EE88"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M116 94.5889L109.757 85.7694C105.992 80.4594 103.972 74.1119 103.972 67.6118V47.8062C103.972 31.6321 92.0361 18.2046 76.458 15.8548V6.36394C76.458 3.95309 74.4993 2 72.0815 2C69.6637 2 67.705 3.95309 67.705 6.36394V15.6717C51.576 17.5637 39.0891 31.2049 39.0891 47.8062V68.3442C39.0891 75.3936 36.7325 82.26 32.3559 87.8141L27 94.6194H116V94.5889Z",
    fill: "#22EE88"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4867_1651)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M116 94.5889L109.757 85.7694C105.992 80.4594 103.972 74.1119 103.972 67.6118V47.8062C103.972 31.6321 92.0361 18.2046 76.458 15.8548V6.36394C76.458 3.95309 74.4993 2 72.0815 2C69.6637 2 67.705 3.95309 67.705 6.36394V15.6717C51.576 17.5637 39.0891 31.2049 39.0891 47.8062V68.3442C39.0891 75.3936 36.7325 82.26 32.3559 87.8141L27 94.6194H116V94.5889Z",
    fill: "#00AA55"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M66.8167 108.993C71.6217 111.007 77.5285 109.969 81.3848 106.491C83.0681 104.965 84.3229 103.012 85.0574 100.875L59.1348 100.692C60.4202 104.354 63.2359 107.498 66.8167 108.993Z",
    fill: "#00AA55"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4867_1651"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 93,
    fill: "white",
    transform: "translate(27 2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.d71065dccde0f58640b3e19eb7f58e8b.svg";
export { ForwardRef as ReactComponent };